import { render, staticRenderFns } from "./CancellationClientAccount.vue?vue&type=template&id=2c33f2f6&"
import script from "./CancellationClientAccount.vue?vue&type=script&lang=js&"
export * from "./CancellationClientAccount.vue?vue&type=script&lang=js&"
import style0 from "./CancellationClientAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports